import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./style/main.scss";
import "./config/i18n.js";
import { AppProvider } from "./context/AppContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>

    <AppProvider>
      <App />
    </AppProvider>

  // </React.StrictMode>
);
reportWebVitals();
